import React, { useCallback } from 'react';

import { ItemsFilters } from '../../../../../types';
import { CategoryID } from '../../../../categories/categoriesTypes';

import { useThreeDStockCategories } from '../../../hooks/useThreeDStockCategories';

import { ThreeDStockBreadcrumbs } from '../ThreeDStockBreadcrumbs';

import { CheckPermissions } from '../../../../../helpers/CheckPermissions';

import { StockPermissions, StockTabs } from '../../../stockConstants';

import { getChangeProductsFiltersCategoriesData } from '../../../../products/utils/getChangeProductsFiltersCategoriesData';

import {
  lifestylesKeys,
  materialsKeys,
  productsKeys
} from '../../../../../locales/keys';
import { getChangeMaterialsFiltersCategoriesData } from '../../../../materials/utils/getChangeMaterialsFiltersCategoriesData';
import { getChangeLifestylesFiltersCategoriesData } from '../../../../lifestyles/utils/getChangeLifestylesFiltersCategoriesData';

const i18nBaseTitles = {
  [StockTabs.PRODUCTS]: productsKeys.plural,
  [StockTabs.LIFESTYLES]: lifestylesKeys.plural,
  [StockTabs.MATERIALS]: materialsKeys.plural
};

type FiltersCategoriesDataCategory = {
  id: CategoryID;
  parent?: {
    id: CategoryID;
  };
};

const getFiltersCategoriesData = (
  tab: StockTabs,
  currentCategory: FiltersCategoriesDataCategory,
  categories: FiltersCategoriesDataCategory[]
) => {
  if (tab === StockTabs.PRODUCTS) {
    return getChangeProductsFiltersCategoriesData({
      productCategory: currentCategory,
      categories
    });
  }

  if (tab === StockTabs.LIFESTYLES) {
    return getChangeLifestylesFiltersCategoriesData({
      lifestyleCategory: currentCategory,
      categories
    });
  }

  if (tab === StockTabs.MATERIALS) {
    return getChangeMaterialsFiltersCategoriesData({
      materialCategory: currentCategory,
      categories
    });
  }
};

interface ThreeDStockContentHeaderProps {
  tab: StockTabs;
  categoryIds?: CategoryID[];
  changeItemsCategoryFilters: (
    tab?: StockTabs,
    changeFilters?: ItemsFilters,
    removeFilters?: string[]
  ) => void;
  isLibrary?: boolean;
}

function ThreeDStockContentHeader({
  tab,
  categoryIds,
  changeItemsCategoryFilters,
  isLibrary
}: ThreeDStockContentHeaderProps) {
  const { categories, categoriesFetched, currentCategoryId } =
    useThreeDStockCategories({
      tab,
      categoryIds
    });

  const handleChangeFilters = useCallback<(categoryId?: CategoryID) => void>(
    (categoryId) => {
      const category = categoryId
        ? categories?.find((category) => category.id === categoryId)
        : undefined;

      const { changeFilters, resetFilters } = getFiltersCategoriesData(
        tab,
        category,
        categories
      );

      changeItemsCategoryFilters(tab, changeFilters, resetFilters);
    },
    [categories, changeItemsCategoryFilters, tab]
  );

  return (
    <div className="w-full">
      <CheckPermissions
        action={StockPermissions.READ_THREE_D_STOCK_BREADCRUMBS}
      >
        <ThreeDStockBreadcrumbs
          onSelect={handleChangeFilters}
          categories={categories}
          currentCategoryId={currentCategoryId}
          categoriesFetched={categoriesFetched}
          i18nBaseTitle={i18nBaseTitles[tab]}
          isLibrary={isLibrary}
        />
      </CheckPermissions>
    </div>
  );
}

export default ThreeDStockContentHeader;
